import React from "react";
import './ChatIntro.css';
export default () =>{
    return (
        <div className="chatIntro">
            <img src="https://www.pngitem.com/pimgs/m/510-5106766_whatsapp-png-icon-download-png-as-icon-logo.png" alt=""></img>
            <h1>Mantenha seu celular conectado</h1>
            <h2>O whatsapp conecta ao seu telefone para sincronizar suas mensagens. <br></br> Para reduzir o uso de dados, conecte seu telefone a uma rede WI-FI.</h2>
        </div>
    )
}